<template>
    <div class="files-list">
        <div
            v-for="file in items"
            :key="file.id"
            class="file"
            :class="getFileType(file)"
            @mouseover="hoveredFileId = file.id"
            @mouseout="hoveredFileId = null"
        >
            <div
                v-if="['image', 'unknown'].indexOf(getFileType(file)) > -1"
                class="icon preview"
                :style="`background-image: url('${file.url}')`"
                @click="downloadFile(file)"
            ></div>
            <div
                v-else class="icon"
                @click="downloadFile(file)">
            </div>
            <div
                class="info"
                @click="downloadFile(file)"
            >
                <span class="name">{{ file.name }}</span>
                <span class="date">{{ file.createdAt | isoWithTime }}</span>
            </div>
            <div
                class="deleting-file-button"
                @click="handlerDeleteFile(file.id)"
                v-show="hoveredFileId === file.id"
            ></div>
            <div
                class="empty-div"
                v-show="hoveredFileId !== file.id"
            ></div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
const filesActions = [
    'deleteFile',
];
export default {
    name: 'FilesList',
    data() {
        return {
            hoveredFileId: null,
        };
    },
    props: {
        items: {
            type: Array,
            required: true,
        },
    },
    methods: {
        getFileType(file) {
            const ext = file.name.split('.').pop().toLowerCase();
            switch (ext) {
                case 'jpg':
                case 'jpeg':
                case 'png':
                case 'bmp':
                case 'gif':
                    return 'image';
                case 'svg':
                    return 'svg';
                case 'pdf':
                    return 'pdf';
                case 'doc':
                case 'docx':
                case 'txt':
                case 'rtf':
                    return 'doc';
                case 'xls':
                case 'xlsx':
                    return 'xls';
                case 'ppt':
                case 'pps':
                case 'pptx':
                    return 'ppt';
                default:
                    return 'unknown';
            }
        },
        downloadFile(file) {
            const win = window.open(file.url, '_blank');
            win.focus();
        },
        async handlerDeleteFile(fileId) {
            try {
                const result = await this.deleteFile(fileId);
                if (result === 'success') {
                    this.items = this.items.filter(file => file.id !== fileId);
                }
            } catch (error) {
                console.log('Deleting denied');
            }
        },
        ...mapActions('mentoring/files', filesActions),
    },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables";
@import '@/styles/rem';
@import '@/styles/mrem';

.files-list{
    display: flex;
    flex-wrap: wrap;
    @include on-mobile{
        flex-wrap: nowrap;
        flex-direction: column;
        align-items: stretch;
    }
    .file{
        display: flex;
        margin-bottom: rem(26);
        cursor: pointer;
        user-select: none;
        @include on-mobile{
            margin-bottom: mrem(24);
        }
        &:nth-child(2n) {
            margin-left: auto;
            @include on-mobile{
                margin-left: 0;
            }
        }
        .deleting-file-button{
            background: url("../../../../../assets/images/icons/delete.svg") round;
            width: rem(14);
            height: rem(14);
            margin: rem(4) rem(15) 0 0;
        }
        .empty-div{
            width: rem(14);
            height: rem(14);
            margin: rem(4) rem(15) 0 0;
        }
        .icon{
            width: rem(64);
            height: rem(64);
            flex-shrink: 0;
            flex-grow: 0;
            background-position: center;
            background-repeat: no-repeat;
            background-size: contain;
            margin-right: rem(12);
            @include on-mobile{
                width: mrem(64);
                height: mrem(64);
                margin-right: mrem(12);
            }
            &.preview{
                border-radius: rem(64);
                overflow: hidden;
                background-color: #DCE8FF;
                background-size: cover;
                @include on-mobile{
                    border-radius: mrem(64);
                }
            }
        }
        .info{
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            .name{
                font-weight: 600;
                font-size: rem(16);
                line-height: rem(24);
                color: #4663AB;
                width: rem(240);
                max-height: rem(48);
                overflow: hidden;
                @include on-mobile{
                    font-size: mrem(16);
                    line-height: mrem(24);
                    width: auto;
                    max-height: mrem(48);
                }
            }
            .date{
                font-size: rem(14);
                line-height: rem(20);
                color: #97A4BA;
                margin-top: rem(4);
                @include on-mobile{
                    font-size: mrem(14);
                    line-height: mrem(20);
                    margin-top: mrem(4);
                }
            }
        }
        &.doc{
            .icon{
                background-image: url('../../../../../assets/images/account/mentoring/files/doc.svg');
            }
        }
        &.pdf{
            .icon{
                background-image: url('../../../../../assets/images/account/mentoring/files/pdf.svg');
            }
        }
        &.ppt{
            .icon{
                background-image: url('../../../../../assets/images/account/mentoring/files/ppt.svg');
            }
        }
        &.svg{
            .icon{
                background-image: url('../../../../../assets/images/account/mentoring/files/svg.svg');
            }
        }
        &.xls{
            .icon{
                background-image: url('../../../../../assets/images/account/mentoring/files/xls.svg');
            }
        }
    }
}
</style>
